import React, { useState, useEffect } from "react";
import "./login-container.styles.scss";
import { Redirect } from "react-router-dom";
import Loading from "../../components/loading/loading.component";
import { User } from "../../@types/user.interface";
import { GlobalState } from "../../redux/root-reducer";
import { fetchApi } from "../../redux/fetch/fetch.actions";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ILoginPayload } from "../../redux/user/user.actions";
import { validateLogin, isBinusEmail } from "../../utils/validation";
import Ribbon from "../../assets/images/png/ribbon.png";
import Logo from "../../assets/images/png/logo_lcas.png";
import LoginForm2 from "../../components/login-form/login-form2.component";
import Axios from "axios";
import EncryptToBase64 from "../../assets/aes";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    login: (data: { username: string; password: string }) => void;
}

interface LoginData {
    username: string;
    password: string;
}

function LoginContainer({ isFetching, errors, login, user }: IProps) {
    const [data, setData] = useState<LoginData>({
        username: "",
        password: "",
    });
    const [error, setError] = useState<string>("");

    useEffect(() => {
        if (isFetching || errors) return;
        sessionStorage.removeItem("_i");
    }, [isFetching, errors]);

    const handleChange = (evt: any, name: string) => {
        let val = evt.target.value;
        setData((prevState) => ({
            ...prevState,
            [name]: val,
        }));
    };

    const handleClick = async (evt: any) => {
        evt.preventDefault();

        let userName = data.username;
        let payload: string | any[] = "";

        if (!isBinusEmail(data.username)) {
            let result;

            try {
                result = await Axios.post(
                    process.env.REACT_APP_DEFAULT_API + "messier/getsalt",
                    { username: data.username }
                );
            } catch (error) {
                if (!error.response) {
                    setError(
                        "Unexpected error, please contact the administrator"
                    );
                } else {
                    setError(error.response.status);
                }
                return;
            }

            if (!result.status || result.statusText !== "OK") {
                setError(result.statusText);
                return;
            }

            payload = EncryptToBase64(
                result.data + data.username,
                data.password
            ).toString();
        } else payload = data.password;

        setError(validateLogin(data, errors));
            login({
                username: userName,
                password: payload.toString(),
            });
    };

    return (
        <div className="login-background container">
            <img
                src={Ribbon}
                alt="Ribbon"
                className="login-background__ribbon"
            />
            <img src={Logo} alt="Logo" className="login-background__logo" />
            {/* <canvas id="c"></canvas> */}
            {isFetching ? (
                <Loading className="fixed" />
            ) : user ? (
                <Redirect to="/home" />
            ) : (
                <LoginForm2
                    handleChange={handleChange}
                    handleClick={handleClick}
                    error={error}
                />
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: {
        self: { data },
    },
}: GlobalState) => ({
    isFetching: isFetching.LOGIN,
    errors: errors.LOGIN,
    user: data,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    login: (data: ILoginPayload["data"]) =>
        dispatch(fetchApi({ name: "LOGIN", data })),
});

const LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginContainer);

export default LoginPage;
